import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface TextProps {
  color?: string;
  fontSize?: keyof typeof fontSizes;
  fontWeight?: keyof typeof fontWeights;
}

/*
 * Style.
 */

interface TextStyleProps {
  $color?: string;
  $fontSize?: keyof typeof fontSizes;
  $fontWeight?: keyof typeof fontWeights;
}

const StyledTextSpan = styled.span<TextStyleProps>`
  ${(p) => p.$color && `color: ${p.$color}`};
  ${(p) => p.$fontSize && `font-size: ${fontSizes[p.$fontSize]}`};
  ${(p) => p.$fontWeight && `font-weight: ${fontWeights[p.$fontWeight]}`};
`;

/*
 * Component.
 */

export const Text: FC<PropsWithChildren<TextProps>> = ({children, ...props}) => (
  <StyledTextSpan $color={props.color} $fontSize={props.fontSize} $fontWeight={props.fontWeight}>
    {children}
  </StyledTextSpan>
);
